import React, { ReactNode, useEffect, useState } from 'react';
import styles from './Layout.module.css';
import Header from '../Header/Header';

interface LayoutProps {
    children: ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
    const [isHoliday, setIsHoliday] = useState(false);

    useEffect(() => {
        // Проверяем, является ли сегодня праздничным днем
        const today = new Date();
        const isChristmas = today.getMonth() === 11 && today.getDate() >= 20 && today.getDate() <= 31;
        const isNewYear = today.getMonth() === 0 && today.getDate() <= 7;

        setIsHoliday(isChristmas || isNewYear);
    }, []);

    return (
        <div className={`${styles.layout} ${isHoliday ? styles.holiday : ''}`}>
            <Header />
            <main className={styles.main}>
                {children}
            </main>
            <footer className={styles.footer}>
                © {new Date().getFullYear()} Vivera Blog
                <a href="/privacy-policy">
                    Политика конфиденциальности
                </a>
            </footer>
        </div>
    );
};

export default Layout;